var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ta-lot-watchlist-count"},[_c('span',[_vm._v(_vm._s(_vm.lot.watchlist_count || 0))]),(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }